var map = {
	"./barImage.svg": 1663,
	"./fastfoodImage.svg": 9824,
	"./hospitalImage.svg": 7130,
	"./libraryImage.svg": 5349,
	"./parkingImage.svg": 7629,
	"./picnicSiteImage.svg": 7946,
	"./pubImage.svg": 6881,
	"./railwayImage.svg": 491,
	"./restaurantImage.svg": 3866,
	"./taxiImage.svg": 1059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3363;